<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>
          Number of bowel movements today
        </p>

        <Radios
          name="bowel-movements"
          :entry="existingEntry"
          @store-number="storeBowelMovements"
          data="bowelMovements"
          amount="11"
        />
      </div>

      <div class="field">
        <p>
          Worst pain during bowel movement today
        </p>

        <Radios
          name="bowel-movement-pain"
          :entry="existingEntry"
          @store-number="storeBowelMovementPain"
          data="bowelMovementPain"
          amount="11"
        />
      </div>

      <div class="field stool-description">
        <p>Stool description, choose all that apply</p>

        <div class="description-wrapper">
          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type1"
              value="0"
            />

            <label for="type1">
              <img src="/app/img/bowel/1.png" alt="" />
              Seperate hard lumps, like nuts
            </label>
          </div>

          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type2"
              value="32"
            />

            <label for="type2">
              <img src="/app/img/bowel/2.png" alt="" />
              Sausage-shaped but lumpy
            </label>
          </div>

          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type3"
              value="65"
            />

            <label for="type3">
              <img src="/app/img/bowel/3.png" alt="" />
              Like a sausage but with cracks on its surface
            </label>
          </div>

          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type4"
              value="100"
            />

            <label for="type4">
              <img src="/app/img/bowel/4.png" alt="" />
              Like a sausage or snake, smooth and soft
            </label>
          </div>

          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type5"
              value="67"
            />

            <label for="type5">
              <img src="/app/img/bowel/5.png" alt="" />
              Soft blobs with clear-cut edges
            </label>
          </div>

          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type6"
              value="34"
            />

            <label for="type6">
              <img src="/app/img/bowel/6.png" alt="" />
              Fluffy pieces with ragged edges, a mushy stool
            </label>
          </div>

          <div class="checkbox">
            <input
              v-model="form.stoolDescription"
              type="checkbox"
              id="type7"
              value="1"
            />

            <label for="type7">
              <img src="/app/img/bowel/7.png" alt="" />
              Watery, no solid pieces
            </label>
          </div>
        </div>
      </div>

      <div class="field">
        <p>How did pelvic pain change after bowel movement</p>
        <div class="radio">
          <input
            type="radio"
            id="better"
            value="better"
            name="pain-after"
            v-model="form.painAfter"
          />
          <label for="better">Better</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="same"
            value="same"
            name="pain-after"
            v-model="form.painAfter"
          />
          <label for="same">Same</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="worse"
            value="worse"
            name="pain-after"
            v-model="form.painAfter"
          />
          <label for="worse">Worse</label>
        </div>
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your bowel movements</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },

  methods: {
    storeBowelMovements(level) {
      this.form.bowelMovements = level;
    },
    storeBowelMovementPain(level) {
      this.form.bowelMovementPain = level;
    },
  },

  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        bowelMovements: this.existingEntry
          ? this.existingEntry.data.bowelMovements
          : 0,
        bowelMovementPain: this.existingEntry
          ? this.existingEntry.data.bowelMovementPain
          : 0,
        stoolDescription: this.existingEntry
          ? this.existingEntry.data.stoolDescription
          : [],
        painAfter: this.existingEntry ? this.existingEntry.data.painAfter : "",
      },
    };
  },
};
</script>

<style>
button {
  margin-right: 1rem;
}

.checkbox {
  align-items: flex-start;
  display: inline-block;
  flex-direction: column;
  position: relative;
}

.checkbox img {
  display: block;
  margin-bottom: 0.5rem;
}

.checkbox label {
  cursor: pointer;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
}

.checkbox input {
  background: transparent;
  appearance: none;
  border: 0;
}

.checkbox input:checked::after {
  background: var(--michigan-blue) url(/app/img/check.svg) no-repeat center;
  border-radius: 100%;
  content: "";
  display: block;
  position: absolute;
  right: 1rem;
  top: 2rem;
  height: 2.25rem;
  width: 2.25rem;
}

.description-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: -1rem;
}

.description-wrapper .checkbox {
  padding: 1rem;
  width: 25%;
}

.stool-description {
  margin-bottom: 2rem;
}

.radio {
  align-items: center;
  display: flex;
  margin-bottom: 0.5rem;
}

.radio input {
  height: auto;
  margin: 0 0.5rem 0 0;
}
</style>
